export const changeLanguageAutomatic = (code: String) => {
    var desiredLang = "en";
    if (code == "GR") {
        desiredLang = "el";
    }
    var urlPath = window.location.pathname;
    var lang = urlPath.split("/")[1];
    return urlPath.replace("/" + lang + "/", "/" + desiredLang + "/");
};

export const getLanguage = () => {
    var urlPath = window.location.pathname;
    var lang = urlPath.split("/")[1];
    if (lang == null) {
        lang = "en";
    }
    return lang;
};

export const getLanguageFromUrl = (url: String) => {
    var urlPath = url;
    var lang = urlPath.split("/")[1];
    if (lang == null) {
        lang = "en";
    }
    return lang;
};

export const fixUrlLanguage = (url: String) => {
    var url_lang = getLanguageFromUrl(url);
    var desired_lang = getLanguage();
    return url.replace("/" + url_lang + "/", "/" + desired_lang + "/");
};
